/*
* Created on Jan 22, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useState, useEffect, useRef} from 'react';
import { useTranslation } from "react-i18next";
import {DEFAULT_SIZE_LIST, ORGANIZATION_NAME_FORMAT} from "../../service/common";
import ic_content_settings from '../../static/img/content/ic-content-settings.svg';
import ic_status_check_svg from '../../static/img/utils/ic-status-checked.svg';
import SettingsAvatarModal from "./SettingsAvatarModal";
import {useQuery} from "@tanstack/react-query";
import {useParams} from "react-router-dom";
import MainContentPlaceholderComponent from "../main-content/MainContentPlaceholderComponent";
import {useAuthSession} from "../../context/AuthSessionContext";
import TextInputComponent from "../common/Form/TextInputComponent";
import SelectInputComponent from "../common/Form/SelectInputComponent";
import {useAlertContext} from "../../context/AlertContext";
import SubmitButtonComponent from "../common/Form/SubmitButtonComponent";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import {useOrganization} from "../../context/OrganizationContext";
import {useRegion} from "../../context/RegionContext";
import CountrySelectComponent from "../common/Form/CountrySelectComponent";
import useEmailChangedHook from "../../hook/EmailChangedHook";
import TextAreaComponent from "../common/Form/TextAreaComponent";
import SettingsAuthentication from "./settingsAuthentication";


const init_input = {
    name: {value: '', error: null, required: true, init_value: ''},
    description: {value: '', error: null, required: false, init_value: ''},
    country: {value: '', error: null, required: true, init_value: ''},
    size: {value: '', error: null, required: false, init_value: ''},
    website: {value: '', error: null, required: false, init_value: ''},
    phone: {value: '', error: null, required: false, init_value: ''},
    avatars: {value: '', error: null, required: false, init_value: ''}
}


const SecurityIndexComponent = () => {
    const {OrganizationAPI} = useOrganizationApi();
    const {useCheckSession} = useAuthSession();
    const {oid} = useParams();
    const {t} = useTranslation();
    const [refresh, setRefresh] = useState(1);
    const { data, isSuccess } = useQuery({
        queryKey: [`organization/${oid}`, refresh],
        queryFn: async () => {
            const org = await OrganizationAPI.get(`organization/${oid}`);
            return org.result;
        }
    });
    useCheckSession();

    return (
        <div className="content content-page">
            <div className="content-title">
                <div className="title-ic"><img src={ic_content_settings} alt=""/></div>
                <div className="title-label">{t('@Security@')}</div>
            </div>

            {window._env_.REACT_APP_ENABLE_SSO === 'true' && data &&
                <>
                    <SettingsAuthentication organization_id={oid} hash_code={data?.hash_code} organization={data}/>
                </>
            }
        </div>
    );
};

export default SecurityIndexComponent;